import { ICrmParameter } from '@/features/dataSourceEdit/types';
import { FC } from 'react';
import { CheckInstallationMessage } from './CheckInstallationMessage';
import { useTranslation } from 'react-i18next';
import { CheckInstallationList } from './CheckInstallationList';

type CheckInstallationParametersListProps = {
  listItems: ICrmParameter[];
};

export const CheckInstallationParametersList: FC<CheckInstallationParametersListProps> = ({ listItems }) => {
  const { t } = useTranslation('data_source_edit');

  return (
    <CheckInstallationList listItems={listItems} empyListMessage={t('crm.check_installation.no_parameters')}>
      {listItems.map((param) => (
        <CheckInstallationMessage key={param.parameterId} asListItem>
          {param.description}: {param.name}
        </CheckInstallationMessage>
      ))}
    </CheckInstallationList>
  );
};
